export default "__VITE_ASSET__CI6Mmh8x__"